<template>
  <div>
    <Skeleton v-if="loading" class="skeleton"></Skeleton>

    <a-popover v-if="!loading && hasContactDetails"
               v-model="visible" trigger="click hover">
      <template slot="content">
        <div class="contact-details-container">
          <div class="contact-details-avatar">
            <img :src="avatar || '/assets/img/blank_avatar.png'" alt="Avatar" class="img-circle"/>
          </div>

          <div class="contact-details-name-function">
            <div><strong>{{ name || 'Onbekend' }}</strong></div>
            <div>{{ subtitle || '-' }}</div>
          </div>

          <div class="contact-details-phone-email">
            <div><phone-icon title="Telefoon"/> {{ phone || '-'}}</div>
            <div><email-icon title="E-mail"/> {{ email || '-' }}</div>
          </div>

          <div class="contact-details-call-to-action">
            <a v-if="ctaUri" :href="ctaUri" target="_blank">
              <arrow-right-circle-outline-icon title="Bekijk meer details" class="contact-details-cta-icon"/>
            </a>

            <arrow-right-circle-outline-icon v-else title="Meer details niet beschikbaar" class="contact-details-cta-icon cta-inactive"/>
          </div>
        </div>

      </template>

      <span>
        {{ name || 'Onbekend' }} <information-outline-icon title="Info" class="contact-details-info-icon"/>
      </span>
    </a-popover>

    <span v-if="!loading && !hasContactDetails">Onbekend</span>
  </div>
</template>

<script>
import {Skeleton} from 'vue-loading-skeleton';

export default {
  name: "ContactDetailsComponent",
  components: {
    Skeleton,
  },
  props: {
    id: {
      type: [String, Number],
      default: null,
    },
    avatar: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
    subtitle: {
      type: String,
      default: null,
    },
    phone: {
      type: String,
      default: null,
    },
    email: {
      type: String,
      default: null,
    },
    ctaUri: {
      type: String,
      default: null,
    },
    loading: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    hasContactDetails() {
      return this.name !== null || this.email !== null || this.phone !== null
    },
  },
}
</script>

<style scoped>
.contact-details-container {
  display: flex;
  gap: 1em;
}
.contact-details-avatar,
.contact-details-call-to-action {
  display: flex;
  align-items: center;
}
.contact-details-name-function,
.contact-details-phone-email {
  flex-direction: column;
  display: flex;
  justify-content: center;
}
.img-circle {
  height: 4em;
  width: 4em;
}
.contact-details-cta-icon {
   height: 40px;
   width: 40px;
}
.contact-details-cta-icon > svg {
  height: 40px;
  width: 40px;
}
.cta-inactive {
  opacity: 0.3;
}
.contact-details-info-icon {
  color: #1890ff;
}
.skeleton {
  border-color: rgb(217, 217, 217);
  border-radius: 4px;
  height: 1.5em;
  width: 100%;
}
</style>